import {
  axiosInstance
} from './axiosInstance';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';

export const getBusinessDetails = async () => {
  let response;
  const businessId = sessionStorage.getItem('businessId');

  try {
    if (businessId) {
      response = await axiosInstance.get(`/business-detail/${businessId}`);
    } else {
      response = {};
    }

  } catch (err) {
    response = handleErrorResponse(err);
  }

  return response;
};

export const setBusinessDetails = async (data) => {
  let response;
  const businessId = data?.businessId;

  try {
    if (businessId) {
      response = await axiosInstance.patch(`/business-detail/${businessId}`, data);
    } else {
      response = await axiosInstance.post('/business-detail', data);
      if (response?.data?.businessId) {
        sessionStorage.setItem('businessId', response?.data?.businessId);
      }
    }

  } catch (err) {
    response = handleErrorResponse(err, data);
  }

  return response;
};
